import { useCallback, useRef } from 'react'

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Dialog, DialogProps, IconButton, Tooltip } from '@mui/material'

import { isScrollEnd } from '../../utilities/scroll'

import styles from './styles.module.scss'

interface ModalProps {
  title?: string | null
  content: React.ReactNode
  open: boolean
  onClose: () => void
  height?: string | 'auto'
  textTooltip?: string
  footer?: React.ReactNode
  setScrollBottom?: (value: boolean) => void
}
export const Modal = ({
  title,
  content,
  open,
  onClose,
  height = 'auto',
  textTooltip,
  footer,
  setScrollBottom,
  fullScreen,
  ...rest
}: ModalProps & Omit<DialogProps, 'content'>) => {
  const divContent = useRef<HTMLDivElement>(null)

  const checkScrollPosition = useCallback(() => {
    if (divContent.current && setScrollBottom) {
      setScrollBottom(isScrollEnd(divContent.current))
    }
  }, [divContent.current, setScrollBottom])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      {...rest}
      maxWidth={false}
    >
      <div
        className={styles.container}
        style={{ height: fullScreen ? '100vh' : height }}
      >
        <div className={styles.header}>
          {title && (
            <div className={styles.title}>
              <h5>{title}</h5>
              {textTooltip && (
                <Tooltip title={textTooltip} placement="right">
                  <HelpOutlineIcon
                    fontSize="small"
                    className={styles.helpIcon}
                  />
                </Tooltip>
              )}
            </div>
          )}
          <IconButton
            aria-label="Close modal"
            component="span"
            onClick={onClose}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </div>
        <div
          className={styles.content}
          onScroll={checkScrollPosition}
          ref={divContent}
        >
          {content}
        </div>
        {footer}
      </div>
    </Dialog>
  )
}
